import styled from 'styled-components';

export const ProductEditWrapper = styled.section`
  padding: 30px 34px;
`;
